enum AttendancesTypes {
  Consolidated,
  Procedures,
  DaysWorked,
}

export default AttendancesTypes;
